import { SKRFraga } from "@/types/skr";

export const skrFragorData: SKRFraga[] = [
  // Storlek
  {
    id: "storlek-byggtid",
    text: "Hur lång är projektets beräknade totala byggtid?",
    kategori: "Storlek",
    hjalptext: "Bedöm total byggtid från etablering till slutbesiktning.",
    skala: "Mycket låg <1 mån · Låg 1–6 mån · Medel 6–18 mån · Hög 18–36 mån · Mycket hög >36 mån"
  },
  {
    id: "storlek-personer",
    text: "Hur många personer kommer arbeta samtidigt i byggskedet?",
    kategori: "Storlek",
    hjalptext: "Antal personer som samtidigt arbetar på arbetsstället.",
    skala: "Mycket låg <5 · Låg 5–15 · Medel 15–50 · Hög 50–150 · Mycket hög >150"
  },
  {
    id: "storlek-persondagar",
    text: "Uppskattat antal persondagar totalt? (Gräns: >500 kräver förhandsanmälan)",
    kategori: "Storlek",
    hjalptext: "Uppskattat antal persondagar totalt. >500 kräver förhandsanmälan.",
    skala: "Mycket låg <100 · Låg 100–500 · Medel 500–5 000 · Hög 5 000–50 000 · Mycket hög >50 000"
  },
  {
    id: "storlek-entreprenorer",
    text: "Antal olika entreprenörer/projektörer involverade?",
    kategori: "Storlek",
    hjalptext: "Antal olika entreprenörer och projektörer som är involverade.",
    skala: "Mycket låg 1 · Låg 2–3 · Medel 4–15 · Hög 16–50 · Mycket hög >50"
  },
  {
    id: "storlek-etablering",
    text: "Är etablering och logistik en utmaning?",
    kategori: "Storlek",
    hjalptext: "Bedöm utifrån tillgänglighet, transport och uppställningsytor.",
    skala: "Mycket låg = fria ytor och egen infart · Medel = begränsat utrymme · Mycket hög = etablering i drift, delade ytor, flera etapper"
  },

  // Komplexitet
  {
    id: "komplexitet-teknisk",
    text: "Innehåller projektet tekniskt komplicerade moment (t.ex. installationer, specialkonstruktioner)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm teknisk svårighetsgrad och specialistkrav.",
    skala: "Mycket låg = standardutförande · Medel = flera installationsdiscipliner · Mycket hög = specialkonstruktioner utan färdig lösning"
  },
  {
    id: "komplexitet-samverkande",
    text: "Flera projektörer eller samverkande konstruktioner (t.ex. stål/betong)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm samordningskomplexitet mellan olika konstruktionstyper.",
    skala: "Mycket låg = en konstruktionstyp · Medel = två samverkande · Mycket hög = många samverkande system med kritiska gränssnitt"
  },
  {
    id: "komplexitet-samtidiga",
    text: "Samtidiga arbeten, trånga ytor eller ombyggnad i befintlig miljö?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm arbetsmiljöutmaningar och samordningssvårigheter.",
    skala: "Mycket låg = ett arbetslag i taget · Medel = planerade parallella arbeten · Mycket hög = ständigt samtidiga arbeten på trånga ytor"
  },
  {
    id: "komplexitet-pagaende",
    text: "Ska verksamhet pågå parallellt med byggnation (t.ex. sjukhus, skola)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm påverkan på pågående verksamhet.",
    skala: "Mycket låg = tomt objekt · Medel = verksamhet intill · Mycket hög = känslig verksamhet (vård, skola) i drift under hela byggtiden"
  },
  {
    id: "komplexitet-andra",
    text: "Behöver lösningar samordnas med andra byggherrar/verksamheter?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm extern samordningskomplexitet.",
    skala: "Mycket låg = ingen extern part · Medel = enstaka ledningsägare · Mycket hög = flera byggherrar och myndigheter med egna tidplaner"
  },
  {
    id: "komplexitet-tidsplan",
    text: "Finns risker kopplade till tidsplanen (t.ex. för snäva tidsramar, parallella arbeten eller brist på tid för säkerhetsåtgärder)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm tidsplanens påverkan på arbetsmiljön, stress och säkerhetsåtgärder.",
    skala: "Mycket låg = god marginal · Medel = pressad men rimlig · Mycket hög = tidplanen förutsätter att skyddsåtgärder kortas"
  },
  {
    id: "komplexitet-kommunikation",
    text: "Finns risk för bristande kommunikation eller otydliga ansvarsgränser mellan aktörer?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm kommunikationsrisker och ansvarsgränser mellan olika aktörer.",
    skala: "Mycket låg = tydliga gränser och få aktörer · Medel = vissa oklara gränssnitt · Mycket hög = otydligt ansvar, flera språk, hög omsättning"
  },
  {
    id: "komplexitet-forandringar",
    text: "Finns rutiner för att hantera förändringar i projektet (t.ex. nya aktörer, ändrade metoder, ändrad tidplan)?",
    kategori: "Komplexitet",
    hjalptext: "Bedöm hur väl projektorganisationen hanterar oförutsedda ändringar.",
    skala: "Mycket låg = etablerad ändringsrutin · Medel = rutin finns men följs olika · Mycket hög = ingen rutin, ändringar sker löpande"
  },

  // Risknivå
  {
    id: "risk-sarskilda",
    text: "Förekommer arbeten med särskild risk (enl. AFS 2023:3 kap. 11 §12)? Exempel: arbete på hög höjd, kemikalier, rivning, sprängning, mm.",
    kategori: "Risknivå",
    hjalptext: "Bedöm förekomst av högriskarbeten enligt AFS 2023:3 kap. 11 §12.",
    skala: "Mycket låg = ingen av de 13 punkterna · Medel = 1–2 punkter · Hög = 3–5 punkter · Mycket hög = fler än 5 eller livsfarliga moment"
  },
  {
    id: "risk-samordning",
    text: "Risk för samordningsproblem mellan aktörer på plats?",
    kategori: "Risknivå",
    hjalptext: "Bedöm risker för krockar mellan olika arbetsgrupper.",
    skala: "Mycket låg = ingen samtidighet · Medel = planerbara krockar · Mycket hög = dagliga krockar med tunga lyft eller heta arbeten"
  },
  {
    id: "risk-yttre",
    text: "Finns yttre riskfaktorer (trafik, väder, höjd, vatten, spår)?",
    kategori: "Risknivå",
    hjalptext: "Bedöm externa risker som påverkar arbetsmiljön.",
    skala: "Mycket låg = inomhus, avskilt · Medel = trafik eller väderexponering · Mycket hög = spårtrafik, vatten, hög höjd eller allmänhet nära"
  },
  {
    id: "risk-projektering",
    text: "Behöver vissa arbetsmiljöfrågor hanteras särskilt i projekteringen (AFS 2023:3 kap. 9–10)?",
    kategori: "Risknivå",
    hjalptext: "Bedöm behov av särskild arbetsmiljöprojektering.",
    skala: "Mycket låg = inga särskilda frågor · Medel = enstaka frågor · Mycket hög = flera frågor som styr konstruktionsval"
  },
  {
    id: "risk-nya-metoder",
    text: "Används nya eller oprövade metoder, tekniker eller material som kan innebära särskilda risker?",
    kategori: "Risknivå",
    hjalptext: "Bedöm okända risker med nya material, metoder eller tekniker.",
    skala: "Mycket låg = enbart beprövat · Medel = ny metod för entreprenören · Mycket hög = oprövad teknik utan erfarenhetsunderlag"
  },
  {
    id: "risk-arbetsbelastning",
    text: "Finns risk för hög arbetsbelastning, stress eller bristande återhämtning under projektets gång?",
    kategori: "Risknivå",
    hjalptext: "Bedöm psykosocial arbetsmiljö och risk för utmattning.",
    skala: "Mycket låg = normal arbetstid · Medel = perioder av övertid · Mycket hög = skiftarbete, ständig övertid, hög personalomsättning"
  },

  // Förväntad åtgärdsnivå
  {
    id: "atgard-bas",
    text: "Kommer projektet kräva: Byggherren utser Bas-P/Bas-U",
    kategori: "Förväntad åtgärdsnivå",
    hjalptext: "Bedöm om Bas-P/Bas-U krävs enligt regelverket.",
    skala: "Mycket låg = ej aktuellt · Medel = krävs, enkel omfattning · Mycket hög = krävs, med särskilda kompetenskrav och egen organisation"
  },
  {
    id: "atgard-amp",
    text: "Kommer projektet kräva: Arbetsmiljöplan (enligt kap. 11)",
    kategori: "Förväntad åtgärdsnivå",
    hjalptext: "Bedöm om arbetsmiljöplan krävs.",
    skala: "Mycket låg = ej aktuellt · Medel = mini-AMP räcker · Mycket hög = full AMP som revideras löpande"
  },
  {
    id: "atgard-dokumentation",
    text: "Kommer projektet kräva: Dokumentation för bruksskedet (kap. 10)?",
    kategori: "Förväntad åtgärdsnivå",
    hjalptext: "Bedöm om dokumentation för bruksskedet krävs.",
    skala: "Mycket låg = ej aktuellt · Medel = begränsad dokumentation · Mycket hög = omfattande drift- och underhållsunderlag med kvarvarande risker"
  }
];